import { render, staticRenderFns } from "./NewGuestBooking.vue?vue&type=template&id=80f1cfbc&scoped=true"
import script from "./NewGuestBooking.vue?vue&type=script&lang=js"
export * from "./NewGuestBooking.vue?vue&type=script&lang=js"
import style0 from "./NewGuestBooking.vue?vue&type=style&index=0&id=80f1cfbc&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "80f1cfbc",
  null
  
)

export default component.exports